import {HTMLProps} from "react";

interface LabelProps extends HTMLProps<HTMLDivElement>{
    mt?: number,
    mb?: number,
}

/**
 *
 * @param children
 * @param mt
 * @param mb
 * @param props
 * @constructor
 * @deprecated
 */
const Label = ({children, mt=4, mb=2, ...props}: LabelProps) => {
    return <div className={`modal-label mt-${mt} mb-${mb}`} {...props}>{children}</div>
}
export default Label;
